import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HealthHero from './components/HealthHero';
import HealthContent from './components/HealthContent';

const HealthPage = () => {
  usePageMeta({
    title: '健康企業宣言 | 株式会社MSK',
    ogTitle: '健康企業宣言 | 株式会社MSK',
    description: '株式会社MSKの健康企業宣言および健康経営への取り組みをご紹介いたします。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <HealthHero />
        <HealthContent />
      </main>
      <Footer />
    </div>
  );
};

export default HealthPage;
